import { type ReactNode } from 'react';
import { cn } from '@/utils/tailwind.util';
import styles from './Toggle.module.scss';
type ToggleProps = {
  isOn: boolean;
  disabled?: boolean;
  setIsOn: () => void;
  onDescription?: ReactNode;
  offDescription?: ReactNode;
  className?: string;
};

/**
 * @deprecated Use Toggle from @/ui_v3/components/control/Toggle instead
 */
export default function Toggle(props: ToggleProps) {
  return <div className={cn(styles.toggle_container, props.className, {
    'pointer-events-none': props.disabled,
    'cursor-pointer': !props.disabled
  }, props.disabled && 'opacity-[0.72]')} onClick={props.setIsOn} data-sentry-component="Toggle" data-sentry-source-file="Toggle.tsx">
      <div className={cn(styles.toggle_base, props.isOn ? 'bg-primary-default' : 'bg-gray-200', props.disabled && props.isOn && 'bg-primary-disabled', props.disabled && !props.isOn && 'bg-gray-200')}>
        <div className={cn('relative size-[18px] bg-white rounded-full transition-[left] duration-100 ease-out', {
        'bg-opacity-white-8': props.disabled
      })} style={{
        left: props.isOn ? 18 : 0
      }}></div>
      </div>
      {props.isOn && !!props.onDescription && <div className={'text-body-lg-semibold'}>{props.onDescription}</div>}
      {!props.isOn && !!props.offDescription && <div className={'text-body-lg-semibold'}>{props.offDescription}</div>}
    </div>;
}